import * as storage from "../util/storage";
import { environment } from "../config/environment";

export default async function uploadProjectsFile(tenantGuid, file) {
  const { apiUrl :  API_URI }  = environment;
  const accessToken = await storage.getAccessToken();
  const bearer = `Bearer ${accessToken}`;

  const url = `${API_URI}/projects/upload`;

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(url, {
    method: "POST",
    headers: {
      authorization: bearer,
      Tenant: tenantGuid,
    },
    body: formData,
  });

  return response;
}
